import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import PublicRoute from './components/PublicRoute/PublicRoute';
import RouteGuard from './components/RouteGuard/RouteGuard';
import AccessDenied from './pages/AccessDenied/AccessDenied';

// Importing all the pages
import Dashboard from './components/Dashboard/Dashboard';
import AccessControlDevice from './pages/AccessControlDevice/AccessControlDevice';
import AccessControlEmployer from './pages/AccessControlEmployer/AccessControlEmployer';
import AccessControlEntry from './pages/AccessControlEntry/AccessControlEntry';
import AdministrationCompany from './pages/AdministrationCompany/AdministrationCompany';
import Agent from './pages/Agent/Agent';
import Company from './pages/Company/Company';
import NewCompany from './pages/Company/NewCompany/NewCompany';
import CompanyGroup from './pages/CompanyGroup/CompanyGroup';
import NewAdditionalAct from './pages/Contract/AdditionalAct/NewAdditionalAct';
import ContractPage from './pages/Contract/Contract';
import NewContract from './pages/Contract/NewContract/NewContract';
import DeviceType from './pages/DeviceType/DeviceType';
import InterventionFilePage from './pages/Dispatch/InterventionFiles/InterventionFile';
import InterventionFilePreview from './pages/Dispatch/InterventionFiles/InterventionFilePreview/InterventionFilePreview';
import InterventionFileRecommendations from './pages/Dispatch/InterventionFiles/InterventionFileRecomandations/InterventionFileRecomandations';
import InterventionFileSupplies from './pages/Dispatch/InterventionFiles/InterventionFileSupplies/InterventionFileSupplies';
import InterventionFileTable from './pages/Dispatch/InterventionFiles/InterventionFileTable/InterventionFileTable';
import ManageMyMentenancePlanning from './pages/Dispatch/MentenancePlanning/ManageMyMentenancePlanning/ManageMyMentenancePlanning';
import MentenancePlanning from './pages/Dispatch/MentenancePlanning/MentenancePlanning';
import CreateRequestFile from './pages/Dispatch/RequestFiles/CreateRequestFile/CreateRequestFile';
import EditRequestFile from './pages/Dispatch/RequestFiles/EditRequestFile/EditRequestFile';
import Dispatch from './pages/Dispatch/RequestFiles/RequestFiles';
import Home from './pages/Home/Home';
import InfoDevice from './pages/InfoDevice/InfoDevice';
import InterventionFileProject from './pages/InterventionFileProject/InterventionFileProject';
import InterventionFileProjectTable from './pages/InterventionFileProject/InterventionFileProjectTable/InterventionFileProjectTable';
import Notification from './pages/Notification/Notification';
//import InterventionFileProjectPage from './pages/InterventionFileProject/InterventionFileProjectPage';
import KPIArhive from './pages/KPI/KPIArhive';
import KPIWeek from './pages/KPI/KPIWeek';
import KPIDynamic from './pages/KPIDynamic/KPIDynamic';
import Labor from './pages/Labor/Labor';
import LaborExtra from './pages/LaborExtra/LaborExtra';
import Login from './pages/Login/Login';
import Logout from './pages/Logout/Logout';
import NewOffer from './pages/Offer/NewOffer/NewOffer';
import OfferPage from './pages/Offer/Offer';
import NewPmContract from './pages/PmContract/NewContract/NewPmContract';
import NewPmAdditionalAct from './pages/PmContract/PmAdditionalAct/NewPmAdditionalAct';
import PmContractPage from './pages/PmContract/PmContract';
import NewPmContractProject from './pages/PmContractProject/NewContractProject/NewPmContractProject';
import NewPmAdditionalActProject from './pages/PmContractProject/PmAdditionalProjectAct/NewPmAdditionalAct';
import PmContractProjectPage from './pages/PmContractProject/PmContractProject';
import NewPmOffer from './pages/PmOffer/NewPmOffer/NewPmOffer';
import PmOfferPage from './pages/PmOffer/PmOffer';
import NewPmOfferProject from './pages/PmOfferProject/NewPmOfferProject/NewPmOfferProject';
import PmOfferProject from './pages/PmOfferProject/PmOfferProject';
import Product from './pages/Product/Product';
import Provider from './pages/Provider/Provider';
import ProviderGroupPage from './pages/ProviderGroup/ProviderGroup';
import NewProviderWorkPlace from './pages/ProviderWorkPlace/NewProviderWorkPlace/NewProviderWorkPlace';
import ProviderWorkPlace from './pages/ProviderWorkPlace/ProviderWorkPlace';
import ReportFinancialContract from './pages/ReportContractFinancial/Report';
import ReportFinancialOffer from './pages/ReportOfferFinancial/Report';
import ReportPMFinancial from './pages/ReportPMFinancial/Report';
import SystemType from './pages/SystemType/SystemType';
import TimeKeeperDevice from './pages/TimeKeeperDevice/TimeKeeperDevice';
import TimeKeeperEmployer from './pages/TimeKeeperEmployer/TimeKeeperEmployer';
import TimeKeeperEntry from './pages/TimeKeeperEntry/TimeKeeperEntry';
import TimeKeeperSystemType from './pages/TimeKeeperSystemType/TimeKeeperSystemType';
import NewUser from './pages/User/NewUser/NewUser';
import User from './pages/User/User';
import UserGroupPage from './pages/UserGroup/UserGroup';
import NewWorkPlace from './pages/WorkPlace/NewWorkPlace/NewWorkPlace';
import WorkPlace from './pages/WorkPlace/WorkPlace';

const App: FC = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route
        index
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />

      {/* Private Routes */}
      <Route
        path='/*'
        element={
          <PrivateRoute>
            <RouteGuard>
              <Dashboard>
                <Routes>
                  {/* Home and Logout */}
                  <Route path='/home' element={<Home />} />
                  <Route path='/logout' element={<Logout />} />
                  <Route path='/access-denied' element={<AccessDenied />} />
                  {/* Access Control */}
                  <Route path='/access-control/employer' element={<AccessControlEmployer />} />
                  <Route path='/access-control/entry' element={<AccessControlEntry />} />
                  <Route path='/access-control/device' element={<AccessControlDevice />} />
                  {/* Administration */}
                  <Route path='/panel/administrationCompany' element={<AdministrationCompany />} />
                  <Route path='/panel/agent' element={<Agent />} />
                  <Route path='/notifications' element={<Notification />} />
                  {/* Company & Related */}
                  <Route path='/panel/company' element={<Company />} />
                  <Route path='/panel/company/new' element={<NewCompany />} />
                  <Route path='/panel/company/edit' element={<NewCompany />} />
                  <Route path='/panel/companyGroup' element={<CompanyGroup />} />
                  <Route path='/panel/workPlace' element={<WorkPlace />} />
                  <Route path='/administration/workPlace/new' element={<NewWorkPlace />} />
                  <Route path='/administration/workPlace/edit' element={<NewWorkPlace />} />
                  {/* Provider & Related */}
                  <Route path='/panel/provider' element={<Provider />} />
                  <Route path='/panel/providerGroup' element={<ProviderGroupPage />} />
                  <Route path='/panel/providerWorkPlace' element={<ProviderWorkPlace />} />
                  <Route path='/administration/providerWorkPlace/new' element={<NewProviderWorkPlace />} />
                  <Route path='/administration/providerWorkPlace/edit' element={<NewProviderWorkPlace />} />
                  {/* User & Groups */}
                  <Route path='/administration/user/new' element={<NewUser />} />
                  <Route path='/administration/user/edit' element={<NewUser />} />
                  <Route path='/panel/user' element={<User />} />
                  <Route path='/panel/userGroup' element={<UserGroupPage />} />
                  {/* System and Device Types */}
                  <Route path='/panel/systemType' element={<SystemType />} />
                  <Route path='/panel/deviceType' element={<DeviceType />} />
                  <Route path='/panel/infoDevice' element={<InfoDevice />} />
                  <Route path='/panel/product' element={<Product />} />
                  {/* Labor */}
                  <Route path='/panel/labor' element={<Labor />} />
                  <Route path='/panel/laborExtra' element={<LaborExtra />} />
                  {/* Contract Management */}
                  <Route path='/service-maintenance/contract/new' element={<NewContract />} />
                  <Route path='/service-maintenance/contract/edit' element={<NewContract />} />
                  <Route path='/service-maintenance/contract/act-additionally/edit' element={<NewAdditionalAct />} />
                  <Route path='/service-maintenance/contract/active-contracts' element={<ContractPage />} />
                  {/* PM Contracts */}
                  <Route path='/project-management/pmContract/new' element={<NewPmContract />} />
                  <Route path='/project-management/pmContract/edit' element={<NewPmContract />} />
                  <Route path='/project-management/pmContract/active-pmContracts' element={<PmContractPage />} />
                  <Route
                    path='/project-management/pmContract/pmact-additionally/edit'
                    element={<NewPmAdditionalAct />}
                  />
                  <Route
                    path='/project-management/pmContractProject/active-pmContractProjects'
                    element={<PmContractProjectPage />}
                  />
                  <Route path='/project-management/pmContractProject/new' element={<NewPmContractProject />} />
                  <Route path='/project-management/pmContractProject/edit' element={<NewPmContractProject />} />
                  <Route
                    path='/project-management/pmContractProject/pmAdditionalActProject-additionally/edit'
                    element={<NewPmAdditionalActProject />}
                  />
                  <Route
                    path='/project-management/pmOfferProject/active-pmOfferProjects'
                    element={<PmOfferProject />}
                  />
                  <Route path='/project-management/pmOfferProject/new' element={<NewPmOfferProject />} />
                  <Route path='/project-management/pmOfferProject/edit' element={<NewPmOfferProject />} />
                  {/* Offers */}
                  <Route path='/service-maintenance/offer/new' element={<NewOffer />} />
                  <Route path='/service-maintenance/offer/edit' element={<NewOffer />} />
                  <Route path='/service-maintenance/offer/active-offers' element={<OfferPage />} />
                  {/* PM Offers */}
                  <Route path='/project-management/pmOffer/new' element={<NewPmOffer />} />
                  <Route path='/project-management/pmOffer/edit' element={<NewPmOffer />} />
                  <Route path='/project-management/pmOffer/active-pmoffers' element={<PmOfferPage />} />
                  {/* Reports */}
                  <Route path='/cashflow/contract' element={<ReportFinancialContract />} />
                  <Route path='/cashflow/offer' element={<ReportFinancialOffer />} />
                  <Route path='/project-management/financial-report' element={<ReportPMFinancial />} />
                  {/* Dispatch */}
                  <Route path='/service-maintenance/dispatch/dispatch' element={<Dispatch />} />
                  <Route path='/service-maintenance/dispatch/new' element={<CreateRequestFile />} />
                  <Route path='/service-maintenance/dispatch/edit' element={<CreateRequestFile />} />
                  <Route path='/service-maintenance/dispatch/view' element={<EditRequestFile />} />
                  <Route path='/service-maintenance/dispatch/maintenancePlanning' element={<MentenancePlanning />} />
                  <Route
                    path='/service-maintenance/dispatch/myMaintenancePlannings'
                    element={<ManageMyMentenancePlanning />}
                  />
                  {/* Intervention Files */}
                  <Route path='/service-maintenance/interventionFile/new' element={<InterventionFilePage />} />
                  <Route path='/service-maintenance/interventionFile/edit' element={<InterventionFilePage />} />
                  <Route path='/service-maintenance/interventionFile/preview/:id' element={<InterventionFilePreview />} />
                  <Route path='/service-maintenance/interventionFiles' element={<InterventionFileTable />} />
                  <Route path='/service-maintenance/interventionFile/supplies' element={<InterventionFileSupplies />} />
                  <Route
                    path='/service-maintenance/interventionFile/recommendations'
                    element={<InterventionFileRecommendations />}
                  />
                  <Route path='/project-management/interventionFileProject/new' element={<InterventionFileProject />} />
                  <Route
                    path='/project-management/interventionFileProject/edit'
                    element={<InterventionFileProject />}
                  />
                  <Route
                    path='/project-management/interventionFileProjects'
                    element={<InterventionFileProjectTable />}
                  />

                  {/* Time Keeper */}
                  <Route path='/time-keeper/employer' element={<TimeKeeperEmployer />} />
                  <Route path='/time-keeper/entry' element={<TimeKeeperEntry />} />
                  <Route path='/time-keeper/systemType' element={<TimeKeeperSystemType />} />
                  <Route path='/time-keeper/device' element={<TimeKeeperDevice />} />
                  {/* KPI */}
                  <Route path='/kpi/week' element={<KPIWeek />} />
                  <Route path='/kpi/arhive' element={<KPIArhive />} />
                  <Route path='/kpi/dynamic' element={<KPIDynamic />} />
                </Routes>
              </Dashboard>
            </RouteGuard>
          </PrivateRoute>
        }
      />

      {/* Catch-all 404 route */}
      <Route path='*' element={<p># 404</p>} />
    </Routes>
  );
};

export default App;
